
import axios from "axios";
import { API_URL } from "../config";

const dailySummaryervice = {
  async getDailySummaryByDate(startDate,endDate) {
    try {
      const token = localStorage.getItem("token");
      const headers = { "auth-key": token }
      
      const posUrl = `${API_URL}/SRD/GetInvoice?p_start_date=${startDate}&p_end_date=${endDate}`;
      const otherInvoiceUrl = `${API_URL}/OtherInvoice/GetOtherInvoiceByDateRange?p_startDate=${startDate}&p_endDate=${endDate}`;
      
      // const response = await axios.get(url, {
      //   headers: {
      //     "auth-key": token,
      //   },
      // });

      // return response.data;

      const [posResponse, otherInvoiceResponse] = await Promise.all([
        axios.get(posUrl, { headers }),
        axios.get(otherInvoiceUrl, { headers })
      ]);

      let otherSales = otherInvoiceResponse.data.ResultSet || [];

      // 2. If otherSales exist, fetch the details for EACH invoice (N+1 query)
      if (otherSales.length > 0) {
        const detailPromises = otherSales.map(invoice => 
          axios.get(`${API_URL}/OtherInvoice/GetOtherInvoice?p_invId=${invoice.POI_INV_ID}`, { headers })
            .catch(() => null) // catch individual errors so Promise.all doesn't fail
        );

        const detailsResponses = await Promise.all(detailPromises);

        // 3. Merge the details back into the otherSales array
        otherSales = otherSales.map((invoice, index) => {
          const detailData = detailsResponses[index]?.data?.ResultSet;
          return {
            ...invoice,
            // Attach the details array if the API returns it
            POI_OTHERINVOICE_DETAILS: detailData?.POI_OTHERINVOICE_DETAILS || [] 
          };
        });
      }

      return {
        posSales: posResponse.data.ResultSet || [],
        otherSales: otherSales
      };

    } catch (error) {
      throw error;
    }
  },
};

export default dailySummaryervice;